export const adminTheme = {
    background: "#f8f9fa", // Light background for customer panel
    color: "#000",         // Black text for readability
    navbarBg: "#ffffff",   // White navbar
    footerBg: "#e9ecef",   // Light grey footer
  };
  
  export const customerTheme = {
    background: "#f8f9fa", // Light background for customer panel
    color: "#000",         // Black text for readability
    navbarBg: "#ffffff",   // White navbar
    footerBg: "#e9ecef",   // Light grey footer
  };

  export const driverTheme = {
    background: "#f8f9fa", // Light background for customer panel
    color: "#000",         // Black text for readability
    navbarBg: "#ffffff",   // White navbar
    footerBg: "#e9ecef",   // Light grey footer
  };
  